<div class="usage-cell-renderer">
  <span class="sent">&#x2B06;</span> {{getUnits(usage.sent)}} <span class="received">&#x2B07;</span> {{getUnits(usage.received)}};
</div>
